import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import { RootStoreState, vaultStoreActions } from '@app/root-store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { AuthService, CommonService, DocumentService, FolderFileUpdateCommonFileUploadService } from '@app/shared/services';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { DragDropService } from '@app/shared/services/drag-drop/drag-drop.service';
import { FileDataObjectTransferService } from '@app/shared/services/file-data-object-transfer/file-data-object-transfer.service';
import { ModalService } from '@app/shared/services/Modal/modal.service';
import { OfficeService } from '@app/shared/services/office/office.service';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import { fetchAuthSession } from 'aws-amplify/auth';
import { stat } from 'fs';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import * as vaultSelectors from '@app/root-store/vault-store/vault.selector';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { CommonModule } from '@angular/common';
import { FileTypeListSizeEnum, FileUploadedLimitExtension } from '@app/enum/FileTypeListSizeEnum';
interface DIRECTORY {
  name: string;
  data: any;
  children?: DIRECTORY[];
}

let TREE_DATA: DIRECTORY[] = [];

interface DirectoryFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  data: any;
  completed: boolean;
}
export enum VaultUserFormOrigin {
  workspace = 'workspace',
  vault = 'vault',
  officeVault = 'office-vault',
}
export enum fileStatus {
  success = 'success',
  fail = 'fail',
  running = 'running',
}

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'common-upload-dialog',
  templateUrl: './common-upload-dialog.component.html',
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./common-upload-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonUploadDialogComponent implements OnInit, OnDestroy {
  files: any = [];
  treeDataNode = [];
  fileListDataTree = [];
  FiletListDataList: Array<any> = [];
  display$: Observable<'open' | 'close'>;
  fileCompltedStack = [];
  itemCounter = 0;

  data: any = [];
  subscription = new Subscription();
  currentWorkspaceOwner;
  manageSecuritykey = null;
  TREE_DATA;
  vaultStateObject;
  securityStateObject;
  isSecurityKeyAdded = false;
  // formEncryptionKey;
  origin = 'vault';
  showFileUploadArea = true;
  showLader = false;
  sk;
  isOficeWorkSpace = false;
  progressdata: any = [];
  currentWorkSpaceId;
  security_key;

  // Worker references for proper cleanup
  private activeWorkers: Map<string, Worker> = new Map();

  private transformer = (node: any, level: number) => {
    let data = node.data;
    data.originalFile = node.originalFile;
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      data: data,
    };
  };
  FileUploadedLimit = FileTypeListSizeEnum.FileUploadedLimit;
  FileUploadedLimitExtension = FileUploadedLimitExtension;

  treeControl = new FlatTreeControl<DirectoryFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  vaultUserID$ = this.store.pipe(select(vaultSelectors.getcurrentVaultUserId()));
  screenWidth: number;
  constructor(
    private modalService: ModalService,
    private toastr: ToastrService,
    private officeService: OfficeService,
    private router: Router,
    private loginService: LoginStoreEffects,
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private vaultService: VaultStoreEffects,
    private folderFileUpdateCommonFileUploadService: FolderFileUpdateCommonFileUploadService,
    private store$: Store<RootStoreState.State>,
    private cryptoService: CryptoService,
    private dragDropService: DragDropService,
    private commonService: CommonService,
    private fileDataObjectTransferService: FileDataObjectTransferService,

    private store: Store,
    private authService: AuthService
  ) {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
      })
    );
  }

  hasChild = (_: number, node: DirectoryFlatNode) => node.expandable;

  expandNode() {
    this.treeControl.expand(this.treeControl.dataNodes[4]);
    this.treeControl.expand(this.treeControl.dataNodes[5]);
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.subscription.add(
      this.fileDataObjectTransferService.getMessage().subscribe((val) => {
        if (val.text == 'cloesedNoFile' && this.fileCompltedStack.length == 0) {
          this.DoneCliek();
        } else if (val.text == 'isLogout') {
          this.DoneCliek();
        } else {
          this.showLader = val.text == 'true' ? true : false;
        }

        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.fileDataObjectTransferService.currentApprovalStageMessage.subscribe((data) => {
        if (Object.keys(data).length) {
          this.showFileUploadArea = true;
          this.StareUploadingNewData(data);
          // this.data.push(data);
          // this.FiletListDataList.push(data);
          // this.StartUploading(this.data.length - 1, data['workspaceId'], data['folderId']);
        }
      })
    );
    this.display$ = this.modalService.watch();
    if (this.router.url.includes('my-workspace')) {
      this.origin = 'workspace';
    }
    const url = this.router.url.split('/');
    if (url.length == 3 && url[1] == 'vault' && url[2] == 'my-workspace') {
      this.isOficeWorkSpace = false;
    }
    if (this.router.url.includes('my-workspace')) {
      this.isOficeWorkSpace = true;
    }
    if (url[2] == 'my-workspace' || url[1] == 'office') {
      this.currentWorkSpaceId = url[3];

      // const workspace_selector = this.store$.pipe(select(workspace_selectors.getWorkspace(this.currentWorkSpaceId)));
      // this.subscription.add(
      //   workspace_selector.subscribe((res) => {
      //     this.currentWorkspaceOwner = res.workspaceOwner;
      //   })
      // );
    }
  }

  StartUploading(StackIndex, workspaceId, folderId, vault_folder_id, userId) {
    this.currentWorkSpaceId = workspaceId;

    // const workspace_selector = this.store$.pipe(select(workspace_selectors.getWorkspace(this.currentWorkSpaceId)));
    // this.subscription.add(
    //   workspace_selector.subscribe((res) => {
    //     this.currentWorkspaceOwner = res.workspaceOwner;
    //   })
    // );
    if (this.router.url.includes('my-workspace')) {
      this.origin = 'workspace';
    }
    const url = this.router.url.split('/');
    if (url.length == 3 && url[1] == 'vault' && url[2] == 'my-workspace') {
      this.isOficeWorkSpace = false;
    }
    if (this.router.url.includes('my-workspace')) {
      this.isOficeWorkSpace = true;
    }

    if (this.data[StackIndex].fromDrag) {
      this.getDraggedItem(StackIndex, workspaceId, folderId, vault_folder_id, userId);
    } else {
      this.getUploadedItem(StackIndex, workspaceId, folderId);
    }
  }

  getDraggedItem(StackIndex, workspaceId, folderId, vault_folder_id, userId) {
    for (let i = 0; i < this.data[StackIndex].items.length; i++) {
      let item = this.data[StackIndex].items[i].webkitGetAsEntry();

      let fileList = this.data[StackIndex].fileLists[i];
      item.size = fileList.size;
      item.type = fileList.type;
      item.completed = false;
      if (item) {
        this.scanAndLogFiles(item, StackIndex, workspaceId, folderId);
      }
    }
    setTimeout(() => {
      for (var i = StackIndex; i < this.dataSource.data.length; i++) {
        if (i > StackIndex) {
          this.data.push(this.dataSource.data[i]);
          this.FiletListDataList.push(this.dataSource.data[i]);
        }

        this.updalodsAllDocuments([this.dataSource.data[i]], folderId, workspaceId, null, false, vault_folder_id, userId, null);
      }
    }, 5000);
  }
  async StareUploadingNewData(data) {
    this.showLader = true;
    if (this.progressdata.findIndex((x) => x.name == data.data.name && x.uniquesKey == data.data.uniquesKey) == -1) {
      let isUploadDedByFolder = false;
      if (data.isUploadDedByFolder) {
        isUploadDedByFolder = true;
      }
      this.updalodsAllDocuments(
        [data.data],
        data['folderId'],
        data['workspaceId'],
        data['url'],
        isUploadDedByFolder,
        data['vault_folder_id'],
        data['userId'],
        data['groupId']
      );

      this.createrTreeStructureData([data.data], isUploadDedByFolder);
      this.progressdata = this.progressdata.concat([data.data]);
      this.dataSource.data = this.progressdata;
    }
  }
  async createGroupData(parentFolderData, userId) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./bulk-file-create-group.worker', import.meta.url), { type: 'module' });
        const workerId = `createGroup_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        let data = {
          token: '',
          vault_user_folder_id: '',
          url: '',
          user_id: '',
          name: '',
        };

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.vault_user_folder_id = parentFolderData;
        data.url = `${environment.apiUrl}/api/vault/group`;
        data.user_id = userId;
        let date = new Date();
        data.name = 'Uploaded Files ' + date.toDateString();
        worker.onmessage = ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPair({}));
      }
    });
  }

  getUploadedItem(StackIndex, workspaceId, folderId) {
    const files = this.data.fileLists;
    this.data.folderList = [...files];
    this.getFoldersAndFiles(this.data[StackIndex]?.folderList, StackIndex, workspaceId, folderId);
  }

  getFoldersAndFiles(formList, StackIndex, workspaceId, folderId) {
    const tree = this.dragDropService.parsePathArray(formList);
    TREE_DATA = [...tree];
    this.dataSource.data = [...TREE_DATA];
    this.cd.markForCheck();
  }

  async CreteFolderWorkert(data, element, workspaceId, parentFolderData, url, isUploadDedByFolder, vault_folder_id, userId) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./bulk-file-upload.worker', import.meta.url), { type: 'module' });
        const workerId = `createFolder_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        if ((url.includes('vault') && url.includes('folder')) || (url.includes('admin=true') && url.includes('network'))) {
          data.custom_folder_name = data.name;
          data.is_custom_folder = true;
          data.vault_user_folder_id = parentFolderData;
          data.url = `${environment.apiUrl}/api/vault/subfolder-user`;
          data.parent_office_workspace_folder_id = null;
          data.parent_office_vault_folder_id = null;
          data.vault_folder_id = vault_folder_id;
          data.user_id = userId;
        } else {
          if (workspaceId == -1) {
            data.workspaceId = null;
            data.url = `${environment.apiUrl}/api/office-vault/folder`;
          } else {
            data.url = `${environment.apiUrl}/api/office/workspace-folder`;
          }
        }

        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);

          if (element.children.length) {
            let result;
            if (element.children.filter((x) => x.originalFile != null).length) {
              result = await this.createGroupData(data.data.id, data.data.user_id);
            }
            this.updalodsAllDocuments(
              element.children,
              data.data.id,
              workspaceId,
              url,
              isUploadDedByFolder,
              vault_folder_id,
              userId,
              result?.data?.id
            );
          }
          this.checkElemtneedToudapte(workspaceId, parentFolderData);
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPair(data));
      }
    });
  }
  generateDataKeyPair(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }
  createrTreeStructureData(dataList, isUploadDedByFolder) {
    dataList.forEach(async (element) => {
      if (isUploadDedByFolder) {
        if (element.data.name == element.name) {
          this.cd.detectChanges();
          this.fileListDataTree.push(element);
        } else {
          this.createrTreeStructureData(element.children, isUploadDedByFolder);
        }
      } else {
        if (element.data.isFile) {
          this.cd.detectChanges();
          this.fileListDataTree.push(element);
        } else {
          this.createrTreeStructureData(element.children, isUploadDedByFolder);
        }
      }
    });
    this.showLader = false;
    this.cd.detectChanges();
  }

  updalodsAllDocuments(dataList, parentFolderData, workspaceId, url, isUploadDedByFolder, vault_folder_id, userId, vault_user_group_id) {
    dataList.forEach(async (element) => {
      if (isUploadDedByFolder) {
        if (element.data.name == element.name) {
          this.cd.detectChanges();
          this.uploadDocument(element, element.data.name, 0, parentFolderData, workspaceId, url, vault_user_group_id);
        } else {
          let model;
          if (parentFolderData) {
            model = {
              name: element.name,
              workspace_id: workspaceId,
              parent_office_workspace_folder_id: parentFolderData,
              parent_office_vault_folder_id: parentFolderData,
            };
          } else {
            model = {
              name: element.name,
              workspace_id: workspaceId,
            };
          }
          this.cd.detectChanges();
          this.CreteFolderWorkert(model, element, workspaceId, parentFolderData, url, isUploadDedByFolder, vault_folder_id, userId);
        }
      } else {
        if (element.data.isFile) {
          this.cd.detectChanges();
          this.uploadDocument(element, element.data.name, 0, parentFolderData, workspaceId, url, vault_user_group_id);
        } else {
          let model;
          if (parentFolderData) {
            model = {
              name: element.name,
              workspace_id: workspaceId,
              parent_office_workspace_folder_id: parentFolderData,
              parent_office_vault_folder_id: parentFolderData,
            };
          } else {
            model = {
              name: element.name,
              workspace_id: workspaceId,
            };
          }
          this.cd.detectChanges();
          this.CreteFolderWorkert(model, element, workspaceId, parentFolderData, url, isUploadDedByFolder, vault_folder_id, userId);
        }
      }
    });
    // dataList.forEach((element, index) => {
    //   this.uploadDocument(element, element?.name, index);
    // });
  }

  async CreteFitstFormWithTampletId(data, dataList, dataSourceIndex, workspaceId, parent_office_workspace_folder_id, url, name, vault_user_group_id) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./bulk-file-upload-create-template.worker', import.meta.url), { type: 'module' });
        const workerId = `createTemplate_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/new-vault-user-form-id`;

        //generate encryption key for form and file upload
        let usersPk: any;

        //check to see if this form is part of a workspace, if so use workspace owner for file encryption work
        if (this.origin == 'workspace' && this.currentWorkspaceOwner?.public_key) {
          usersPk = this.currentWorkspaceOwner.public_key;
        } else {
          usersPk = this.securityStateObject.public_key;
        }
        const form_encryption_key = this.cryptoService.generateEncryptionKey(usersPk, null, null);

        //add encryption key to API body call
        data.form_encryption_key = form_encryption_key.encrypted;

        worker.onmessage = ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
          this.uploadFile(
            dataList,
            data['data']['vault_user_form_id']['vault_user_form_id'],
            dataSourceIndex,
            workspaceId,
            form_encryption_key.plain
          );
          let request = {
            user_id: this.securityStateObject.userId,
            user_pk: this.securityStateObject.public_key,
            id: data['data']['vault_user_form_id']['vault_user_form_id'],
            vault_folder_id: null,
            vault_user_folder_id: null,
            form_data: null,
            workspace_folder_id: null,
            notes: null,
            physical_location: null,
            form_name: name.split('.').slice(0, -1).length == 0 ? name : name.split('.').slice(0, -1).join('.'),
            encryption_key: form_encryption_key.encrypted,
          };

          if (parent_office_workspace_folder_id) {
            if (url.includes(VaultUserFormOrigin.vault)) {
              if (url.includes('my-workspace')) {
                request['workspace_folder_id'] = parent_office_workspace_folder_id;
              } else {
                request['vault_user_folder_id'] = parent_office_workspace_folder_id;
              }
            } else {
              if (url.includes('admin=true') && url.includes('network')) {
                request['vault_user_folder_id'] = parent_office_workspace_folder_id;
              } else {
                request['workspace_folder_id'] = parent_office_workspace_folder_id;
              }
            }
          }
          this.saveFormData(request, null, parent_office_workspace_folder_id, workspaceId, url, vault_user_group_id);
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairCreatForm(data));
      }
    });
  }
  generateDataKeyPairCreatForm(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  uploadDocument(dataList, name, dataSourceIndex, parent_office_workspace_folder_id, workspaceId, url, vault_user_group_id) {
    this.showLader = false;
    const data = {
      url: url.replace('/vault/', ''),
      user_id: this.vaultStateObject?.userId,
    };
    this.itemCounter++;
    // this.fileListDataTree.push(dataList);
    this.CreteFitstFormWithTampletId(
      data,
      [dataList],
      dataSourceIndex,
      workspaceId,
      parent_office_workspace_folder_id,
      url,
      name,
      vault_user_group_id
    );
  }

  async saveFormData(request, sk_value, parent_office_workspace_folder_id, workspaceId, url, vault_user_group_id) {
    let isOficeWorkSpace;
    let durl = url.split('/');
    if ((durl.length == 3 && durl[1] == 'vault' && durl[2] == 'my-workspace') || url.includes('network')) {
      isOficeWorkSpace = false;
    }
    if (durl[1] == 'collaboration' && durl[2] == 'admin-workspace') {
      isOficeWorkSpace = true;
    }
    if (this.router.url.includes('my-workspace') || this.router.url.includes('my-shared-workspace')) {
      isOficeWorkSpace = true;
    }

    if (isOficeWorkSpace) {
      request.origin = VaultUserFormOrigin.workspace;
      request.vault_folder_id = null;
      request.vault_user_folder_id = null;
      request.workspace_id = workspaceId;
    } else {
      request.origin = VaultUserFormOrigin.vault;
    }
    if (workspaceId == -1) {
      delete request.workspace_id;
      request.origin = VaultUserFormOrigin.officeVault;
      request.office_vault_folder_id = parent_office_workspace_folder_id;
    }
    this.cd.detectChanges();

    let last_used_sk_value;
    if (sk_value == null && this.security_key != null) {
      last_used_sk_value = this.security_key; //the form was opened with an sk, but was turned off
    }

    let sk_just_enabled = false;
    if (sk_value != null && this.security_key == null) {
      sk_just_enabled = true;
    }
    request['expiration_date'] = null;
    request['expiration_notification'] = null;
    request['recurring_expiration'] = null;
    request['security_key'] = null;
    request['vault_user_group_id'] = vault_user_group_id;
    //check to see if this form is part of a workspace, if so use workspace owner for form encryption work
    if (this.origin == 'workspace' && this.currentWorkspaceOwner?.id) {
      request.user_id = this.currentWorkspaceOwner.id;
      request.user_pk = this.currentWorkspaceOwner.public_key;
    }

    this.updateFormTampletDataworker(request);
    // this.subscription.add(
    //   this.documentService.updateFormTampletData(request, sk_value, last_used_sk_value, this.formEncryptionKey, sk_just_enabled, this.sk).subscribe(
    //     (res) => { },
    //     (error) => {
    //       this.toastr.error(error.error.response.message);
    //     }
    //   )
    // );
  }

  async updateFormTampletDataworker(data) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./bulk-file-upload-save-upadte-form.worker', import.meta.url), { type: 'module' });
        const workerId = `updateForm_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;

        data.url = `${environment.apiUrl}/api/vault/forms-user`;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateCreatePresignedUrl(data));
      }
    });
  }
  generateupdateFormTampletDataworker(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  uploadFile(event, currentFormId, dataSourceIndex, workspaceId, formEncryptionKey) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];

      const fileSizeInKB = element.size / 1024;
      const fileSizeInMB = fileSizeInKB / 1024;
      const extension = element['name'].split('?')[0].split('.').pop();
      if (this.FileUploadedLimitExtension.findIndex((item) => item == extension.toUpperCase()) == -1) {
        this.toastr.error(`This type of file is not supported : ${element['type']}`);
      } else if (fileSizeInMB > this.FileUploadedLimit) {
        this.fileCompltedStack.push({
          path: element?.data?.fullPath,
          status: fileStatus.fail,
        });
        this.toastr.error(`This file exceeds the limit of ${this.FileUploadedLimit} mb`);
        this.checkElemtneedToudapte(workspaceId, null);
      } else {
        this.uploadfileToserver(
          element['name'],
          element['size'],
          element,
          element['type'],
          this.files.length,
          this.files.length + index,
          currentFormId,
          dataSourceIndex,
          workspaceId,
          formEncryptionKey
        );
        this.cd.detectChanges();
      }
    }
  }
  RevieSHowFile() {
    this.showFileUploadArea = !this.showFileUploadArea;
    this.cd.detectChanges();
  }
  uploadfileToserver(fileName, size, file, type, index, currentIndex, currentFormId, dataSourceIndex, workspaceId, formEncryptionKey) {
    const data = {
      vault_user_form_id: currentFormId,
      user_id: this.securityStateObject.userId,
      name: fileName,
      file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
      display_file_name: fileName,
      size: file.originalFile.size,
      type: file.originalFile.type,
    };
    this.CreteCreatePresignedUrl(data, file, workspaceId, fileName, currentIndex, dataSourceIndex, formEncryptionKey);
  }

  async CreteCreatePresignedUrl(data, file, workspaceId, fileName, currentIndex, dataSourceIndex, formEncryptionKey) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./bulk-file-upload-presign-url.worker', import.meta.url), { type: 'module' });
        const workerId = `presignUrl_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/form-upload-file`;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
          let res = data.data;
          if (res['uploadLimitExceeded']) {
            this.fileCompltedStack.push({
              path: file?.data?.fullPath,
              status: fileStatus.fail,
            });
            this.checkElemtneedToudapte(workspaceId, null);
            this.cd.detectChanges();
            return;
          } else if (res['limit_exceeded']) {
            this.fileCompltedStack.push({
              path: file?.data?.fullPath,
              status: fileStatus.fail,
            });
            this.checkElemtneedToudapte(workspaceId, null);
            this.cd.detectChanges();
            return;
          } else {
            this.saveFileAfterS3UrlCrete(res, fileName, currentIndex, file, workspaceId, dataSourceIndex, formEncryptionKey);
          }
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateCreatePresignedUrl(data));
      }
    });
  }
  generateCreatePresignedUrl(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  async saveFileAfterS3UrlCrete(res, fileName, currentIndex, file, workspaceId, dataSourceIndex, formEncryptionKey) {
    this.files.push({
      status: 'Uploading',
      file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
      display_file_name: fileName,
      progressbar: 0,
      name: fileName,
      created_at: res['created_at'],
      delete_id: res['id'],
      delete_upload_path: res['upload_path'],
    });
    const xhr = new XMLHttpRequest();

    let usersPk;
    //check to see if this form is part of a workspace, if so use workspace owner for file encryption work
    if (this.origin == 'workspace' && this.currentWorkspaceOwner?.public_key) {
      usersPk = this.currentWorkspaceOwner.public_key;
    } else {
      usersPk = this.securityStateObject.public_key;
    }

    let encryptedFile;

    encryptedFile = await this.cryptoService.encryptFile(file.originalFile, usersPk, formEncryptionKey, null, null);
    let data = {
      file: file,
      token: null,
      url: null,
      fileType: null,
    };
    this.createFileAfterS3UrlCrete(
      data,
      res['upload_url'],
      file.originalFile.type,
      file,
      workspaceId,
      dataSourceIndex,
      currentIndex,
      fileName,
      encryptedFile,
      res['id']
    );
  }
  async createFileAfterS3UrlCrete(data, url, type, file, workspaceId, dataSourceIndex, currentIndex, fileName, encryptedFile, id) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./bulk-file-upload-s3-image.worker', import.meta.url), { type: 'module' });
        const workerId = `s3Upload_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = url;
        data.fileType = type;
        data.file = file.originalFile;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);

          const newData = {
            display_file_name: fileName,
            id: id,
            status: 'uploaded',
            encryption_key: null,
            premium_encrypted: null,
          };
          this.updateFileStatus(newData, file, workspaceId, dataSourceIndex, currentIndex);

          this.cd.detectChanges();
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generatecreateFileAfterS3UrlCrete(data));
      }
    });
  }
  DoneCliek() {
    this.fileCompltedStack = [];
    this.progressdata = [];
    this.fileListDataTree = [];
    this.dataSource.data = [];
    this.itemCounter = 0;
    this.showFileUploadArea = true;
    this.modalService.close();
    this.cd.detectChanges();
  }
  generatecreateFileAfterS3UrlCrete(data: any): unknown {
    throw new Error('Method not implemented.');
  }
  async updateFileStatus(data, file, workspaceId, dataSourceIndex, currentIndex) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker(new URL('./bulk-file-upload-status-update.worker', import.meta.url), { type: 'module' });
        const workerId = `statusUpdate_${Date.now()}`;
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/form-upload-file`;
        worker.onmessage = ({ data }) => {
          //return security key generated by worker process
          worker.terminate();
          this.activeWorkers.delete(workerId);
          resolve(data);
          this.fileCompltedStack.push({
            path: file?.data?.fullPath,
            status: fileStatus.success,
          });
          this.checkElemtneedToudapte(workspaceId, null);
          this.cd.detectChanges();
          this.dataSource.data[dataSourceIndex].data.completed = true;
          this.files[currentIndex]['status'] = 'Done';
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairFileStatus(data));
      }
    });
  }
  generateDataKeyPairFileStatus(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  checkFileuploadIsdone(item) {
    let index = this.fileCompltedStack.findIndex((x) => x.path == item);
    if (index == -1) {
      return fileStatus.running;
    } else {
      return this.fileCompltedStack[index].status;
    }
  }

  scanAndLogFiles(item, StackIndex, workspaceId, folderId) {
    // const newFile = item.event.dataTransfer.files;
    let newElt = item;

    if (item.isDirectory) {
      let directoryReader = item.createReader();
      directoryReader.readEntries((entries) => {
        entries.forEach((entry) => {
          try {
            // this.readFile(entry, null, null)
          } catch (error) {}

          this.scanAndLogFiles(entry, StackIndex, workspaceId, folderId);
        });
      });
    }

    if (item.isDirectory) {
      newElt.originalFile = undefined;
      this.data[StackIndex].folderList.push(newElt);
      this.getFoldersAndFiles(this.data[StackIndex]?.folderList, StackIndex, workspaceId, folderId);
      this.cd.detectChanges();
    } else {
      item.file((file) => {
        newElt.originalFile = file;
        this.data[StackIndex].folderList.push(newElt);
        this.getFoldersAndFiles(this.data[StackIndex]?.folderList, StackIndex, workspaceId, folderId);
        this.cd.detectChanges();
      });
    }
  }
  checkIsFile(direcive, filesize, name) {
    if (name != filesize.name) {
      return true;
    } else {
      return direcive;
    }
  }
  getSizeInUnits(filesize, name) {
    if (name != filesize.name) {
      return '  -  ';
    } else {
      if (!filesize?.isFile) {
        return '  -  ';
      } else {
        try {
          if (filesize.size == 0 && filesize.originalFile.size == 0) {
            return '  -  ';
          } else {
            const size = this.commonService.getSizeInUnit(filesize.size ? filesize?.size : filesize?.originalFile?.size);
            return size ? size : '  -  ';
          }
        } catch (error) {
          return '  -  ';
        }
      }
    }
  }

  checkElemtneedToudapte(workspaceId, parentFolderData) {
    if (this.itemCounter - this.fileCompltedStack.length == 0) {
      const url = this.router.url.split('/');
      if (url[1] == 'office-network' || url[1] == 'network' || url[1] == 'office' || url[2] == 'my-information') {
        this.subscription.add(this.folderFileUpdateCommonFileUploadService.sendMessage('true'));
      } else if (url[2] == 'my-workspace' || (url[1] == 'office' && workspaceId == url[3])) {
        this.subscription.add(this.folderFileUpdateCommonFileUploadService.sendMessage('true'));
      } else if (url[1] == 'vault' || url[2] == 'folder') {
        if (this.vaultStateObject?.vaultId) {
          this.store$.dispatch(new vaultStoreActions.DefaultFolderRequest(this.securityStateObject.userId, this.vaultStateObject?.vaultId));
        } else {
          this.store$.dispatch(new vaultStoreActions.DefaultFolderRequest(this.securityStateObject.userId));
        }

        this.subscription.add(this.folderFileUpdateCommonFileUploadService.sendMessage('true'));
      }
    }
  }
  closeDialog() {}

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();

    // Terminate all active workers
    this.activeWorkers.forEach((worker, workerId) => {
      worker.terminate();
    });
    this.activeWorkers.clear();
  }
}
